export const imageExtensions = new Set([
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp',
  '.avif',
  '.svg',
  '.eps',
  '.ai',
  '.cdr',
  '.heic',
  '.heif',
  '.tiff',
  '.tif',
  '.bmp',
  '.raw',
  '.cr2',
  '.nef',
  '.arw',
  '.ico',
  '.apng',
  '.jfif',
  '.psd',
]);
